import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';
import "../../../styles/Auth/purchase.css";
import { DateTime } from "luxon";
import { Box, Modal } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { postData, getData, putData, deleteData } from '../../../webService/webservice.js'
import PurchasePaymentLogsPopup from "../Purchase/viewPurchasePaymentPopUp.jsx";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import { useNavigate, useLocation } from 'react-router-dom';
import returnIcon from '@iconify/icons-mdi/keyboard-return';
import printIcon from '@iconify/icons-mdi/printer';
import ViewPurchasePopup from "./viewPurchasePopUp.jsx";
import LabelPrint58 from "./LabelPrint58.jsx";
const PurchasePage = ({ filters }) => {
    const navigate = useNavigate();
    const [isAddPurchase, setIsAddPurchase] = useState(false);
    const [showAddPaymentForm, setShowAddPaymentForm] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [purchases, setPurchases] = useState([]);
    const [openReturnModal, setOpenReturnModal] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [returnItems, setReturnItems] = useState([]);
    const [printItems, setPrintItems] = useState([]);
    const [isPaymentPopup, setIsPaymentPopup] = useState(false);
    const [showLabelPopup, setShowLabelPopup] = useState(false);
    const [editPurchaseId, setEditPurchaseId] = useState(null);
    const [isPaymentPopupOpen, setIsPaymentPopupOpen] = useState(false);
    const [selectedPurchasePaymentLogs, setSelectedPurchasePaymentLogs] = useState(null);
    const [isPurchasePaymentLogPopupOpen, setIsPurchasePaymentLogPopupOpen] = useState(false);
    const printRef = useRef();
    const [finalPrintItems, setFinalPrintItems] = useState([]);
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const [paymentForm, setPaymentForm] = useState({
        purchaseId: "",
        paymentAmount: "",
        paymentMode: "",
        referenceNo: "",
        remarks: ""
    });
    const headings = [
        'SL',
        'Date',
        'Supplier',
        'Invoice Number',
        'Items',
        'TotalQuantity',
        'Amount',
        'Payment Status',
        'Action',
    ];
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#e6cf80',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [PurchaseToDelete, setPurchaseToDelete] = useState(null);
    const [stateError, setStateError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [cityError, setCityError] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [isEditMode, setIsEditMode] = useState(false);
    const [suppliers, setSuppliers] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [attributes, setAttributes] = useState([]);
    const [viewPurchaseData, setViewPurchaseData] = useState(null);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [errors, setErrors] = useState({});
    const sessionToken = sessionStorage.getItem("sessionToken");

    const onPaymentStatusClick = (purchaseId) => {
        // call the fetcher that opens popup when data arrives
        handleViewPurchasePaymentLog(purchaseId);
    };

    const handleOpen = (purchaseId) => {
        setPurchaseToDelete(purchaseId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setPurchaseToDelete(null);
    };

    const handlePrint = () => {
        const multiplied = [];

        printItems.forEach(item => {
            const qty = Number(item.printQty) || 1;
            for (let i = 0; i < qty; i++) {
                multiplied.push(item);
            }
        });

        let html = "";

        multiplied.forEach(item => {
            html += `
            <div style="
                width:200px;
                border:1px solid black;
                padding:10px;
                margin: 10px 4px;
                position:relative;
                min-height:30px;
                font-family:Arial;
            ">
           
                <img src="${item.labelData.qrCode}"
                    style="width:60px;height:60px;position:absolute;top:8px;right:8px;" />
                <div style="padding-left:5px;padding-right:10px;margin-top:4px;">
                    <div style="font-size:12px;font-weight:bold;margin-top:4px;">Code: ${item.labelData.barcodeNumber}</div>
                    <div style="font-size:12px;font-weight:bold;margin-top:4px;">MRP: ₹${item.labelData.sellingPrice}/-</div>
                    <div style="font-size:10px;margin-top:4px;">${item.labelData.purchaseYearMonth}</div>
                </div>

            </div>`;
        });

        const win = window.open("", "", "width=400,height=600");

        win.document.write(`
            <html>
                <head>
                    <style>
                        @page { size: 58mm auto; margin: 0; }
                        body { 
                            margin: 0; 
                            padding: 0; 
                            font-family: Arial;
                        }

                        /* ➜ Add this */
                        .label-container {
                            display: grid;
                            grid-template-columns: repeat(2, 1fr);
                            gap: 6px;                           
                            padding: 6px;
                        }

                        .label-box {
                            width: 100%; 
                            border:2px solid black;
                            padding:10px;
                            min-height:20px;
                            position:relative;
                            font-family:Arial;
                        }
                    </style>
                </head>
                <body>
                    <div class="label-container">
                        ${html}
                    </div>
                </body>
            </html>
            `);


        win.document.close();

        setTimeout(() => {
            win.focus();
            win.print();
            win.close();
        }, 300);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const [formData, setFormData] = useState({
        purchaseInvoiceDate: "",
        purchaseInvoiceNumber: "",
        purchaseInvoiceAmount: "",
        supplierId: "",
        products: [
            {
                productId: "",
                purchaseProductCode: "",
                purchaseQuantity: 0,
                purchasePrice: 0,
                sellingPrice: 0,
            }
        ]
    });

    const handleAddPurchase = async (e) => {
        e.preventDefault();
        setLoading(true);
        const validationErrors = validateFields(formData);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        try {
            const purchaseData = {
                supplierId: formData.supplierId,
                purchaseInvoiceDate: formData.purchaseInvoiceDate,
                purchaseInvoiceNumber: formData.purchaseInvoiceNumber,
                purchaseInvoiceAmount: formData.purchaseInvoiceAmount,
                dueAmount: formData.purchaseInvoiceAmount,
                products: formData.products.map((product) => ({
                    productId: product.productId,
                    productPurchaseCode: product.purchaseProductCode,
                    purchaseQuantity: Number(product.purchaseQuantity),
                    purchasePrice: Number(product.purchasePrice),
                    sellingPrice: Number(product.sellingPrice),
                })),
            };

            console.log("📦 Sending Purchase Data:", JSON.stringify(purchaseData, null, 2));

            // 🧠 1️⃣ Validation for missing supplier
            if (!purchaseData.supplierId) {
                toast.error("Please select a supplier before submitting.");
                setLoading(false);
                return;
            }

            // ✅ 3️⃣ Submit to backend
            const response = await postData("purchases/", purchaseData, sessionToken);

            toast.success(response.message || "Purchase added successfully");

            if (response?.data?.products) {
                setPrintItems(response.data.products);
            }

            // 🔄 4️⃣ Reset Form after successful add
            setFormData({
                purchaseInvoiceDate: "",
                purchaseInvoiceNumber: "",
                purchaseInvoiceAmount: "",
                supplierId: "",
                grandTotal: "",
                paidAmount: "",
                dueAmount: "",
                products: [
                    {
                        productId: "",
                        purchaseProductCode: "",
                        purchaseQuantity: 0,
                        purchasePrice: 0,
                        sellingPrice: 0,
                    },
                ],
            });

            // 🔄 Close popup and refresh table
            setIsAddPurchase(false);
            triggerRefresh();
        } catch (error) {
            console.error("❌ Add Purchase Error:", error);
            toast.error(error.message || "Add Purchase Failed");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdatePurchase = async (e) => {
        e.preventDefault();
        setLoading(true);
        const validationErrors = validateFields(formData);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        try {
            const purchaseData = {
                supplierId: formData.supplierId,
                purchaseInvoiceDate: formData.purchaseInvoiceDate,
                purchaseInvoiceNumber: formData.purchaseInvoiceNumber,
                purchaseInvoiceAmount: formData.purchaseInvoiceAmount,
                dueAmount: formData.purchaseInvoiceAmount,
                products: formData.products.map((product) => ({
                    productId: product.productId,
                    productPurchaseCode: product.purchaseProductCode,
                    purchaseQuantity: Number(product.purchaseQuantity),
                    purchasePrice: Number(product.purchasePrice),
                    sellingPrice: Number(product.sellingPrice),
                })),
            };

            console.log("📦 Sending Purchase Data:", JSON.stringify(purchaseData, null, 2));

            // 🧠 1️⃣ Validation for missing supplier
            if (!purchaseData.supplierId) {
                toast.error("Please select a supplier before submitting.");
                setLoading(false);
                return;
            }

            // ✅ 3️⃣ Submit to backend
            const response = await putData(`purchases/update/${editPurchaseId}`, purchaseData, sessionToken);
            toast.success(response.message || "Purchase updated successfully");

            if (response?.data?.products) {
                setPrintItems(response.data.products);
            }

            // 🔄 4️⃣ Reset Form after successful add
            setFormData({
                purchaseInvoiceDate: "",
                purchaseInvoiceNumber: "",
                purchaseInvoiceAmount: "",
                supplierId: "",
                grandTotal: "",
                paidAmount: "",
                dueAmount: "",
                products: [
                    {
                        productId: "",
                        purchaseProductCode: "",
                        purchaseQuantity: 0,
                        purchasePrice: 0,
                        sellingPrice: 0,
                    },
                ],
            });
            setIsPopupMode(false);
            setIsEditMode(false);
            // 🔄 Close popup and refresh table
            setIsAddPurchase(false);
            triggerRefresh();
            handleClose();
        } catch (error) {
            console.error("❌ Add Purchase Error:", error);
            toast.error(error.message || "Add Purchase Failed");
        } finally {
            setLoading(false);
        }
    };

    const handleViewPurchasePaymentLog = async (purchaseId) => {
        try {
            setLoading(true);

            const sessionToken = sessionStorage.getItem("sessionToken");
            const response = await getData(
                `purchases/purchasepaymentslog/${purchaseId}`,
                sessionToken
            );

            setSelectedPurchasePaymentLogs(response);   // send full response
            setIsPaymentPopupOpen(true);                // open popup

        } catch (err) {
            console.error(err);
            toast.error("Failed to load purchase payment logs");
        } finally {
            setLoading(false);
        }
    };

    const handleAddPurchasePayment = async (e, purchaseId) => {
        e.preventDefault();

        try {
            setLoading(true);

            const payload = {
                purchaseId: purchaseId, // <-- now passed directly
                paymentAmount: Number(paymentForm.paymentAmount),
                paymentMode: paymentForm.paymentMode,
                referenceNo: paymentForm.referenceNo,
                remarks: paymentForm.remarks,
            };
            console.log(payload);
            const sessionToken = sessionStorage.getItem("sessionToken");
            const response = await postData("purchases/purchasepayment", payload, sessionToken);

            toast.success("Payment added successfully");

            // refresh payment logs automatically
            await handleViewPurchasePaymentLog(purchaseId);

            // reset form
            setPaymentForm({
                paymentAmount: "",
                paymentMode: "",
                referenceNo: "",
                remarks: "",
            });

            setShowAddPaymentForm(false)

        } catch (err) {
            console.error("Payment error:", err);
            toast.error("Failed to add payment");
        } finally {
            setLoading(false);
        }
    };

    const fetchPurchase = async (page, limit, searchQuery, filters = {}) => {
        const params = {
            page,
            limit,
            search: searchQuery?.trim() || ""   // ⭐ UNIVERSAL SEARCH KEY
        };

        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;

        try {
            setLoading(true);

            const response = await getData("purchases/purchases", params, sessionToken);

            const wrap = response?.data?.[0];
            const purchaseList = wrap?.paginatedResults || [];
            const totalCount = wrap?.totalCount || 0;
            const totalPages = wrap?.totalPages || 1;

            setPurchases(purchaseList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);

        } catch (error) {
            toast.error(error.message || "Failed to fetch Purchases");
        } finally {
            setLoading(false);
        }
    };

    const handleDeletePurchase = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('sessionToken');
            const response = await deleteData(`purchases/delete/${PurchaseToDelete}`, token);
            toast.success(response.message || "Supplier deleted successfully");
            fetchPurchase(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Supplier");
        }
    }

    useEffect(() => {
        if (!formData.supplierId) return;

        const supplier = suppliers.find(s => s._id === formData.supplierId);
        if (!supplier) return;

        setFormData(prev => ({
            ...prev,
            contactPersonName: supplier.contactPersonName || "",
            supplierEmailAddress: supplier.email || "",
            supplierPhoneNumber: supplier.mobileNumber || ""
        }));
    }, [formData.supplierId, suppliers]);

    useEffect(() => {
        fetchPurchase(currentPage, limit, searchQuery, filters);
    }, [currentPage, limit, refreshKey, searchQuery, filters]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('products/products', {}, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.[0]?.paginatedResults || [];
                console.log(results);
                setProductsList(results);
            } catch (error) {
                console.error("Failed to fetch Products", error);
            }
        };
        const fetchSupplier = async () => {
            try {
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('suppliers/suppliers', {}, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.results || [];
                setSuppliers(results);
            } catch (error) {
                console.error("Failed to fetch Suppliers", error);
            }
        };
        const fetchAttributes = async () => {
            try {
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('attributes/attributes', {}, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.results?.results || [];
                setAttributes(results);
            } catch (error) {
                console.error("Failed to fetch Attributes", error);
            }
        }
        fetchProducts();
        fetchSupplier();
        fetchAttributes();
    }, []);

    const handleViewPurchase = async (purchaseId) => {
        try {
            setLoading(true);

            // Assuming sessionToken is from sessionStorage
            const sessionToken = sessionStorage.getItem("sessionToken");

            // Fetch data using your getData function
            const response = await getData(`purchases/purchase/${purchaseId}`, sessionToken);

            // Check if response is already JSON
            const data = response?.data || response;

            // Set the view data
            setViewPurchaseData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching Purchase:", error);
            toast.error(error.message || "Failed to fetch Purchase data");
        } finally {
            setLoading(false);
        }
    };

    const handleOpenReturnPopup = (purchase) => {
        setSelectedPurchase(purchase);   // all product + color info available
        setReturnItems([]);              // empty list of return items
        setOpenReturnModal(true);
    };

    const updateReturnItem = (index, key, value) => {
        setReturnItems((prev) => {
            const updated = [...prev];
            if (!updated[index]) {
                updated[index] = {
                    productId: selectedPurchase.products[index].productId,
                };
            }
            updated[index][key] = value;
            return updated;
        });
    };

    const submitPurchaseReturn = async () => {
        const payload = {
            purchaseId: selectedPurchase._id,
            supplierId: selectedPurchase.supplierId,
            returnItems,
            reason: "Customer Return"
        };

        console.log("SUBMIT PAYLOAD", payload);

        try {
            const response = await postData("purchasereturns/", payload, sessionToken);
            alert("Purchase Return Added!");
            setOpenReturnModal(false);
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.message || "Something went wrong");
        }
    };

    const handleOpenPrintPopup = (purchase) => {
        console.log("Opened Print Popup for:", purchase);

        // backend already gives labelData 💯
        const itemsWithLabelData = purchase.products.map(p => ({
            ...p,
            labelData: {
                ...p.labelData
            },
            printQty: 1
        }));

        setPrintItems(itemsWithLabelData);
        setFinalPrintItems(itemsWithLabelData);  // initial preview
        setShowLabelPopup(true);
    };

    const exportToExcel = () => {
        if (!purchases || purchases.length === 0) {
            return toast.error("No purchase data available for export");
        }

        const excelData = purchases.map((item, index) => ({
            SL: index + 1,
            Supplier: item.supplierName ||
                item.supplierDetails?.[0]?.supplierName || "—",
            PurchaseDate: item.createdAt
                ? new Date(item.createdAt).toLocaleDateString("en-IN")
                : "—",
            BillNo: item.purchaseInvoiceNumber || "—",
            TotalAmount: item.purchaseInvoiceAmount || 0,
            Quantity: item.purchaseQuantity || 0
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase_Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const fileData = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(fileData, `Purchase_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    const calculateInvoiceAmount = () => {
        let total = 0;

        // 1️⃣ Sum product totals
        formData.products.forEach(prod => {
            const qty = Number(prod.purchaseQuantity || 0);
            const price = Number(prod.purchasePrice || 0);
            total += qty * price;
        });

        // 2️⃣ Apply GST 5%
        const gst = total * 0.05;

        // 3️⃣ Apply deduction
        const deduction = Number(formData.deductionAmount || 0);

        const finalAmount = total + gst - deduction;

        setFormData(prev => ({
            ...prev,
            purchaseInvoiceAmount: finalAmount.toFixed(2)
        }));
    };

    const handleAlphabeticInput = (e, fieldName) => {
        const value = e.target.value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setFormData((prev) => ({ ...prev, [fieldName]: value }));
            if (fieldName === "city") setCityError("");
            if (fieldName === "country") setCountryError("");
            if (fieldName === "state") setStateError("");
        } else {
            if (fieldName === "city") setCityError("Only letters and spaces allowed");
            if (fieldName === "country") setCountryError("Only letters and spaces allowed");
            if (fieldName === "state") setStateError("Only letters and spaces allowed");
        }
    };

    const fetchStockByProductId = async (productId) => {
        if (!productId) return;

        try {
            setLoading(true);

            // 🔥 API call using your wrapper
            const response = await getData(
                `stocks/stock/product/${productId}`,
                {},           // no params required
                sessionToken
            );

            // API returns array of stock entries
            const stockList = response?.data || [];

            // Calculate total stock
            const totalOffline = stockList
                .filter(s => s.type === "Purchase")
                .reduce((sum, s) => sum + (s.offlineQuantity || 0), 0);

            const totalOnline = stockList
                .filter(s => s.type === "Purchase")
                .reduce((sum, s) => sum + (s.onlineQuantity || 0), 0);

            const totalStock = totalOffline + totalOnline;

            return {
                stockList,
                totalOffline,
                totalOnline,
                totalStock
            };

        } catch (error) {
            toast.error(error.message || "Failed to fetch stock");
            return null;
        } finally {
            setLoading(false);
        }
    };

    const validateFields = (data) => {
        let newErrors = {};
        if (!data.purchaseInvoiceDate) newErrors.purchaseInvoiceDate = "Date is required";
        if (!data.purchaseInvoiceAmount) newErrors.purchaseInvoiceAmount = "Amount is required";
        if (!data.purchaseInvoiceNumber) newErrors.purchaseInvoiceNumber = "Invoice Number is required";
        if (!data.products || data.products.length === 0) {
            newErrors.products = "Please add at least one product";
            return newErrors;  // No need to validate more if no products
        }

        // Regex → allows numbers + optional decimals only
        const numberRegex = /^[0-9]*\.?[0-9]+$/;

        data.products.forEach((prod, index) => {

            if (!prod.productId) {
                newErrors[`productId_${index}`] = "Please select a product";
            }

            // QUANTITY
            if (!prod.purchaseQuantity && prod.purchaseQuantity !== 0) {
                newErrors[`purchaseQuantity_${index}`] = "Quantity is required";
            } else if (!numberRegex.test(prod.purchaseQuantity)) {
                newErrors[`purchaseQuantity_${index}`] = "Invalid quantity";
            } else if (Number(prod.purchaseQuantity) <= 0) {
                newErrors[`purchaseQuantity_${index}`] = "Quantity must be greater than 0";
            }

            // PURCHASE PRICE
            if (!prod.purchasePrice && prod.purchasePrice !== 0) {
                newErrors[`purchasePrice_${index}`] = "Purchase price is required";
            } else if (!numberRegex.test(prod.purchasePrice)) {
                newErrors[`purchasePrice_${index}`] = "Invalid purchase price";
            } else if (Number(prod.purchasePrice) <= 0) {
                newErrors[`purchasePrice_${index}`] = "Price must be greater than 0";
            }

            // SELLING PRICE
            if (!prod.sellingPrice && prod.sellingPrice !== 0) {
                newErrors[`sellingPrice_${index}`] = "Selling price is required";
            } else if (!numberRegex.test(prod.sellingPrice)) {
                newErrors[`sellingPrice_${index}`] = "Invalid selling price";
            } else if (Number(prod.sellingPrice) <= 0) {
                newErrors[`sellingPrice_${index}`] = "Selling price must be greater than 0";
            }
        });

        return newErrors;
    }

    function formatDate(dateString) {
        if (!dateString) return "";
        return dateString.split("T")[0];  // Extract YYYY-MM-DD
    }

    return (
        <div className="purchase-layout1">
            <div className="purchase-content1">
                <main className="purchase-main1">
                    {isAddPurchase ? (
                        <div className="add-purchase-form">
                            <h3>Add Purchase</h3>
                            <form className="Purchase-form">

                                {/* SUPPLIER ROW */}
                                <div className="purchase-form-row">
                                    <div className="purchase-form-group">
                                        <label className="input-label">Supplier</label>
                                        <select
                                            className="purchase-input"
                                            value={formData.supplierId || ""}
                                            onChange={(e) => {
                                                const selectedSupplierId = e.target.value;
                                                const selectedSupplier = suppliers.find(s => s._id === selectedSupplierId);

                                                setFormData(prev => ({
                                                    ...prev,
                                                    supplierId: selectedSupplierId,
                                                    contactPersonName: selectedSupplier?.contactPersonName || "",
                                                    supplierEmailAddress: selectedSupplier?.email || "",
                                                    supplierPhoneNumber: selectedSupplier?.mobileNumber || ""
                                                }));
                                            }}
                                        >
                                            <option value="">Select Supplier</option>
                                            {suppliers.map(s => (
                                                <option key={s._id} value={s._id}>{s.supplierName}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="purchase-form-group">
                                        <label className="input-label">Contact Person</label>
                                        <input type="text" className="purchase-input" value={formData.contactPersonName} readOnly />
                                    </div>

                                    <div className="purchase-form-group">
                                        <label className="input-label">Email Address</label>
                                        <input type="text" className="purchase-input" value={formData.supplierEmailAddress} readOnly />
                                    </div>

                                    <div className="purchase-form-group">
                                        <label className="input-label">Supplier Phone Number</label>
                                        <input type="number" className="purchase-input" value={formData.supplierPhoneNumber} readOnly />
                                    </div>
                                </div>

                                {/* INVOICE ROW */}
                                <div className="purchase-form-row">
                                    <div className="purchase-form-group">
                                        <label className="input-label">Invoice Date</label>
                                        <input
                                            type="date"
                                            className={`purchase-input ${errors.purchaseInvoiceDate ? "input-error" : ""}`}
                                            value={formData.purchaseInvoiceDate}
                                            onChange={e => setFormData(prev => ({ ...prev, purchaseInvoiceDate: e.target.value }))}
                                        />
                                    </div>

                                    <div className="purchase-form-group">
                                        <label className="input-label">Invoice Number</label>
                                        <input
                                            type="text"
                                            className={`purchase-input ${errors.purchaseInvoiceNumber ? "input-error" : ""}`}
                                            value={formData.purchaseInvoiceNumber}
                                            onChange={e => setFormData(prev => ({ ...prev, purchaseInvoiceNumber: e.target.value }))}
                                        />
                                    </div>

                                    {/* 🔻 DEDUCTION */}
                                    <div className="purchase-form-group">
                                        <label className="input-label">Deduction Amount</label>
                                        <input
                                            type="number"
                                            className="purchase-input"
                                            value={formData.deductionAmount}
                                            onChange={(e) => {
                                                const deduction = Number(e.target.value || 0);
                                                setFormData(prev => ({ ...prev, deductionAmount: deduction }));
                                                calculateInvoiceAmount(formData.products, deduction);
                                            }}
                                        />
                                    </div>

                                    {/* 🔻 AUTO CALCULATED INVOICE TOTAL */}
                                    <div className="purchase-form-group">
                                        <label className="input-label">Invoice Amount (Auto)</label>
                                        <input
                                            type="number"
                                            className="purchase-input"
                                            value={formData.purchaseInvoiceAmount}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                {/* PRODUCT TABLE */}
                                <div className="purchase-table-wrapper">
                                    <h3 className="section-title">Products</h3>

                                    <table className="purchase-table">
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>HSN Code</th>
                                                <th>Stock</th>
                                                <th>Qty</th>
                                                <th>Purchase Price</th>
                                                <th>Selling Price</th>
                                                <th></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {formData.products.map((prod, index) => (
                                                <tr key={index} className="purchase-row">

                                                    {/* PRODUCT SELECT */}
                                                    <td>
                                                        <Select
                                                            options={productsList.map(p => ({
                                                                value: p._id,
                                                                label: `${p.productCode} - ${p.title}`
                                                            }))}
                                                            value={
                                                                prod.productId
                                                                    ? { value: prod.productId, label: `${prod.productCode} - ${prod.title}` }
                                                                    : null
                                                            }
                                                            onChange={async (selectedOption) => {
                                                                const product = productsList.find(p => p._id === selectedOption.value);

                                                                const stock = await fetchStockByProductId(product._id);

                                                                const updatedProducts = [...formData.products];
                                                                updatedProducts[index] = {
                                                                    ...updatedProducts[index],
                                                                    productId: product._id,
                                                                    productCode: product.productCode,
                                                                    title: product.title,
                                                                    purchasePrice: product.purchasePrice || 0,
                                                                    sellingPrice: product.sellingPrice || 0,
                                                                    gstPercent: product.tax || 0,
                                                                    purchaseQuantity: 0,
                                                                    totalStock: stock?.totalStock || 0,
                                                                };

                                                                setFormData(prev => ({ ...prev, products: updatedProducts }));
                                                                calculateInvoiceAmount(updatedProducts);
                                                            }}
                                                        />
                                                    </td>

                                                    {/* PURCHASE CODE */}
                                                    <td>
                                                        <input type="text" className="purchase-input" />
                                                    </td>

                                                    {/* STOCK */}
                                                    <td>{prod.totalStock || 0}</td>

                                                    {/* QUANTITY */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="purchase-input"
                                                            value={prod.purchaseQuantity}
                                                            onChange={(e) => {
                                                                const updated = [...formData.products];
                                                                updated[index].purchaseQuantity = Number(e.target.value);
                                                                setFormData(prev => ({ ...prev, products: updated }));
                                                                calculateInvoiceAmount(updated);
                                                            }}
                                                        />
                                                    </td>

                                                    {/* PURCHASE PRICE */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="purchase-input"
                                                            value={prod.purchasePrice}
                                                            onChange={(e) => {
                                                                const updated = [...formData.products];
                                                                updated[index].purchasePrice = Number(e.target.value);
                                                                setFormData(prev => ({ ...prev, products: updated }));
                                                                calculateInvoiceAmount(updated);
                                                            }}
                                                        />
                                                    </td>

                                                    {/* SELLING PRICE */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="purchase-input"
                                                            value={prod.sellingPrice}
                                                            onChange={(e) => {
                                                                const updated = [...formData.products];
                                                                updated[index].sellingPrice = Number(e.target.value);
                                                                setFormData(prev => ({ ...prev, products: updated }));
                                                            }}
                                                        />
                                                    </td>

                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn-remove"
                                                            onClick={() => {
                                                                const updated = formData.products.filter((_, i) => i !== index);
                                                                setFormData(prev => ({ ...prev, products: updated }));
                                                                calculateInvoiceAmount(updated);
                                                            }}
                                                        >
                                                            X
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* ADD PRODUCT BUTTON */}
                                    <button
                                        type="button"
                                        className="btn-add-product"
                                        onClick={() => {
                                            const updated = [
                                                ...formData.products,
                                                {
                                                    productId: "",
                                                    productCode: "",
                                                    title: "",
                                                    purchasePrice: 0,
                                                    sellingPrice: 0,
                                                    purchaseQuantity: 0
                                                }
                                            ];
                                            setFormData(prev => ({ ...prev, products: updated }));
                                        }}
                                    >
                                        + Add Product
                                    </button>
                                </div>

                                {/* ACTION BUTTONS */}
                                <div className="Purchase-buttons">
                                    <button className="add-Purchase-button" type="submit" onClick={handleAddPurchase}>
                                        Add Purchase
                                    </button>

                                    <button className="cancel-Purchase-button" onClick={() => setIsAddPurchase(false)}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="Purchase-widgets">
                                <div className="Purchase-widgets-header">
                                    <h3>Purchase</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="Purchase-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="add-Purchase-buttons">
                                    <button className="add-btn-Purchase" onClick={exportToExcel}>Export</button>
                                    <button className="add-btn-Purchase" onClick={() => setIsAddPurchase(true)} >+ Add New Purchase</button>
                                </div>
                            </div>


                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#E6CF80',
                                                        zIndex: 1,

                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {purchases.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No purchases found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            purchases.map((purchase, index) => (
                                                <TableRow key={purchase._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {purchase.purchaseInvoiceDate
                                                                ? DateTime.fromISO(purchase.purchaseInvoiceDate).toFormat("dd LLL yyyy")
                                                                : "—"}
                                                        </Typography>

                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{purchase.supplierDetails?.[0]?.supplierName}</Typography></TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {purchase.purchaseInvoiceNumber}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{purchase.productDetails?.length || 0}</Typography></TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {purchase.products?.reduce((total, item) => total + Number(item.purchaseQuantity || 0), 0) || 0}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {purchase.purchaseInvoiceAmount}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography
                                                            sx={{
                                                                ...commonCellStyle,
                                                                textDecoration: "underline",
                                                                cursor: "pointer",
                                                                color:
                                                                    purchase?.paymentStatus === "Paid"
                                                                        ? "green"
                                                                        : purchase?.paymentStatus === "Unpaid"
                                                                            ? "red"
                                                                            : "orange",
                                                            }}
                                                            onClick={() => handleViewPurchasePaymentLog(purchase._id)}
                                                        >
                                                            {purchase?.paymentStatus === "Unpaid" ? "Due" : purchase?.paymentStatus}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'left' }}>
                                                            <Icon icon={printIcon} width={20} height={20} style={{ cursor: 'pointer' }} onClick={() => handleOpenPrintPopup(purchase)} />
                                                            <Icon icon={plusIcon} width={20} height={20} style={{ cursor: 'pointer' }} onClick={() => handleViewPurchase(purchase._id)} />
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                console.log(purchase);
                                                                setFormData({
                                                                    supplierId: purchase?.supplierId?._id || purchase?.supplierId || "",
                                                                    purchaseInvoiceDate: formatDate(purchase?.purchaseInvoiceDate),
                                                                    purchaseInvoiceNumber: purchase?.purchaseInvoiceNumber || "",
                                                                    purchaseInvoiceAmount: purchase?.purchaseInvoiceAmount || "",

                                                                    products: (purchase?.products || []).map((p) => ({
                                                                        productId: p.productId,
                                                                        productCode: p.productCode,
                                                                        title: p.title,
                                                                        purchaseProductCode: p.purchaseProductCode,
                                                                        purchaseQuantity: p.purchaseQuantity,
                                                                        purchasePrice: p.purchasePrice,
                                                                        sellingPrice: p.sellingPrice,
                                                                        gstPercent: p.gstPercent,
                                                                        totalStock: p.totalStock || 0,
                                                                        totalOffline: p.totalOffline || 0,
                                                                        totalOnline: p.totalOnline || 0,
                                                                    }))
                                                                });

                                                                setEditPurchaseId(purchase._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000' }}
                                                                onClick={() => handleOpen(purchase._id)}
                                                            />
                                                            {/* <Icon icon={returnIcon} width={20} height={20} onClick={() => handleOpenReturnPopup(purchase)}
                                                            style={{ cursor: "pointer" }} /> */}
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <div className="purchase-bottom">
                                <div className="purchase-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="purchase-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="purchase-section spacer"></div>
                                <div className="purchase-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <div className="popup-form-supplier">
                                            <div className="supplier-popup-form">

                                                <h2 className="popup-title">
                                                    {isEditMode ? "Edit Purchase" : "Add Purchase"}
                                                </h2>

                                                {/* ⭐⭐ EDIT PURCHASE FORM ⭐⭐ */}
                                                <form className="Purchase-form" onSubmit={handleUpdatePurchase}>

                                                    {/* SUPPLIER DETAILS */}
                                                    <div className="purchase-form-row">
                                                        <div className="purchase-form-group">
                                                            <label className="input-label">Supplier</label>
                                                            <select
                                                                className="purchase-input"
                                                                value={formData.supplierId || ""}
                                                                onChange={(e) => {
                                                                    const selectedId = e.target.value;
                                                                    const supplier = suppliers.find(s => s._id === selectedId);

                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        supplierId: selectedId,
                                                                        contactPersonName: supplier?.contactPersonName || "",
                                                                        supplierEmailAddress: supplier?.email || "",
                                                                        supplierPhoneNumber: supplier?.mobileNumber || ""
                                                                    }));
                                                                }}
                                                            >
                                                                <option value="">Select Supplier</option>
                                                                {(suppliers || []).map(s => (
                                                                    <option key={s._id} value={s._id}>{s.supplierName}</option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        <div className="purchase-form-group">
                                                            <label className="input-label">Contact Person</label>
                                                            <input type="text" className="purchase-input" readOnly
                                                                value={formData.contactPersonName || ""} />
                                                        </div>

                                                        <div className="purchase-form-group">
                                                            <label className="input-label">Email Address</label>
                                                            <input type="text" className="purchase-input" readOnly
                                                                value={formData.supplierEmailAddress || ""} />
                                                        </div>

                                                        <div className="purchase-form-group">
                                                            <label className="input-label">Supplier Phone Number</label>
                                                            <input type="text" className="purchase-input" readOnly
                                                                value={formData.supplierPhoneNumber || ""} />
                                                        </div>
                                                    </div>

                                                    {/* INVOICE DETAILS */}
                                                    <div className="purchase-form-row">
                                                        <div className="purchase-form-group">
                                                            <label className="input-label">Invoice Date</label>
                                                            <input
                                                                type="date"
                                                                className="purchase-input"
                                                                value={formData.purchaseInvoiceDate || ""}
                                                                onChange={(e) =>
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        purchaseInvoiceDate: e.target.value
                                                                    }))
                                                                }
                                                            />
                                                            {errors.purchaseInvoiceDate && (
                                                                <p className="error-msg">
                                                                    {errors.purchaseInvoiceDate}
                                                                </p>
                                                            )}
                                                        </div>

                                                        <div className="purchase-form-group">
                                                            <label className="input-label">Invoice Number</label>
                                                            <input
                                                                type="text"
                                                                className="purchase-input"
                                                                value={formData.purchaseInvoiceNumber || ""}
                                                                onChange={(e) =>
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        purchaseInvoiceNumber: e.target.value
                                                                    }))
                                                                }
                                                            />
                                                            {errors.purchaseInvoiceNumber && (
                                                                <p className="error-msg">
                                                                    {errors.purchaseInvoiceNumber}
                                                                </p>
                                                            )}
                                                        </div>

                                                        <div className="purchase-form-group">
                                                            <label className="input-label">Invoice Amount</label>
                                                            <input
                                                                type="number"
                                                                className="purchase-input"
                                                                value={formData.purchaseInvoiceAmount || ""}
                                                                onChange={(e) =>
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        purchaseInvoiceAmount: e.target.value
                                                                    }))
                                                                }
                                                            />
                                                            {errors.purchaseInvoiceAmount && (
                                                                <p className="error-msg">
                                                                    {errors.purchaseInvoiceAmount}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* PRODUCT TABLE */}
                                                    <div className="purchase-table-wrapper">
                                                        <h3 className="section-title">Products</h3>

                                                        <table className="purchase-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Product</th>
                                                                    <th>Purchase Code</th>
                                                                    <th>Stock</th>
                                                                    <th>Qty</th>
                                                                    <th>Purchase Price</th>
                                                                    <th>Selling Price</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {formData.products.map((prod, index) => (
                                                                    <tr key={prod._id}>

                                                                        {/* PRODUCT SELECT */}
                                                                        <td>
                                                                            <Select
                                                                                options={(productsList ?? []).map(p => ({
                                                                                    value: p._id,
                                                                                    label: `${p.productCode} - ${p.title}`
                                                                                }))}

                                                                                value={
                                                                                    (productsList ?? [])
                                                                                        .filter(p => p._id === prod.productId)
                                                                                        .map(p => ({
                                                                                            value: p._id,
                                                                                            label: `${p.productCode} - ${p.title}`
                                                                                        }))[0] || {
                                                                                        value: prod.productId,
                                                                                        label: `${prod.productCode} - ${prod.title}`
                                                                                    }
                                                                                }


                                                                                onChange={async (selected) => {
                                                                                    const product = productsList.find(p => p._id === selected.value);

                                                                                    const updated = [...formData.products];
                                                                                    updated[index] = {
                                                                                        ...updated[index],
                                                                                        productId: product._id,
                                                                                        title: product.title,
                                                                                        productCode: product.productCode,
                                                                                        purchasePrice: product.purchasePrice,
                                                                                        sellingPrice: product.sellingPrice,
                                                                                    };

                                                                                    setFormData(prev => ({
                                                                                        ...prev,
                                                                                        products: updated
                                                                                    }));
                                                                                }}
                                                                                placeholder="Select product..."
                                                                                classNamePrefix="select"
                                                                            />
                                                                            <div className="meta-text">
                                                                                {prod.categoryName} • {prod.subCategoryName}
                                                                            </div>
                                                                            {errors[`productId_${index}`] && (
                                                                                <p className="error-msg">{errors[`productId_${index}`]}</p>
                                                                            )}
                                                                        </td>

                                                                        {/* PURCHASE CODE */}
                                                                        <td>
                                                                            <input type="text" className="purchase-input"
                                                                                value={prod.purchaseProductCode || ""}
                                                                                onChange={(e) => {
                                                                                    const updated = [...formData.products];
                                                                                    updated[index].purchaseProductCode = e.target.value;
                                                                                    setFormData({ ...formData, products: updated });
                                                                                }}
                                                                            />
                                                                        </td>

                                                                        {/* Total Stock */}
                                                                        <td>
                                                                            {prod.totalStock > 0 || prod.offlineStock > 0 || prod.onlineStock > 0 ? (
                                                                                <div className="flex flex-col text-sm leading-tight">

                                                                                    {/* TOTAL STOCK */}
                                                                                    <span className="font-semibold text-gray-800">
                                                                                        Total: {prod.totalStock || 0}
                                                                                    </span>

                                                                                    {/* OFFLINE STOCK */}
                                                                                    <span className="text-blue-600">
                                                                                        Offline: {prod.offlineStock || 0}
                                                                                    </span>

                                                                                    {/* ONLINE STOCK */}
                                                                                    <span className="text-green-600">
                                                                                        Online: {prod.onlineStock || 0}
                                                                                    </span>
                                                                                </div>
                                                                            ) : (
                                                                                <span className="text-red-500 font-medium">0</span>
                                                                            )}
                                                                        </td>
                                                                        {/* QTY */}
                                                                        <td>
                                                                            <input type="number" className="purchase-input"
                                                                                value={prod.purchaseQuantity || ""}
                                                                                onChange={(e) => {
                                                                                    const updated = [...formData.products];
                                                                                    updated[index].purchaseQuantity = Number(e.target.value);
                                                                                    setFormData({ ...formData, products: updated });
                                                                                }}
                                                                            />
                                                                            {errors[`purchaseQuantity_${index}`] && (
                                                                                <p className="error-msg">{errors[`purchaseQuantity_${index}`]}</p>
                                                                            )}
                                                                        </td>

                                                                        {/* PURCHASE PRICE */}
                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="purchase-input"
                                                                                value={prod.purchasePrice || ""}
                                                                                onChange={(e) => {
                                                                                    const updated = [...formData.products];
                                                                                    updated[index].purchasePrice = Number(e.target.value);
                                                                                    setFormData({ ...formData, products: updated });
                                                                                }}
                                                                            />
                                                                            {errors[`purchasePrice_${index}`] && (
                                                                                <p className="error-msg">{errors[`purchasePrice_${index}`]}</p>
                                                                            )}
                                                                        </td>

                                                                        {/* SELLING PRICE */}
                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="purchase-input"
                                                                                value={prod.sellingPrice || ""}
                                                                                onChange={(e) => {
                                                                                    const updated = [...formData.products];
                                                                                    updated[index].sellingPrice = Number(e.target.value);
                                                                                    setFormData({ ...formData, products: updated });
                                                                                }}
                                                                            />
                                                                            {errors[`sellingPrice_${index}`] && (
                                                                                <p className="error-msg">{errors[`sellingPrice_${index}`]}</p>
                                                                            )}
                                                                        </td>

                                                                        {/* REMOVE ROW */}
                                                                        <td>
                                                                            <button
                                                                                type="button"
                                                                                className="btn-remove"
                                                                                onClick={() => {
                                                                                    const updated = formData.products.filter((_, i) => i !== index);
                                                                                    setFormData(prev => ({ ...prev, products: updated }));
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>

                                                        {/* ADD PRODUCT */}
                                                        <button
                                                            type="button"
                                                            className="btn-add-product"
                                                            onClick={() =>
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    products: [
                                                                        ...prev.products,
                                                                        {
                                                                            _id: crypto.randomUUID(),  // ⭐ Unique row key
                                                                            productId: "",
                                                                            productCode: "",
                                                                            title: "",
                                                                            purchasePrice: 0,
                                                                            sellingPrice: 0,
                                                                            purchaseProductCode: "",
                                                                            purchaseQuantity: 0
                                                                        }
                                                                    ]
                                                                }))
                                                            }
                                                        >
                                                            + Add Product
                                                        </button>
                                                    </div>

                                                    {/* SUBMIT BUTTON */}
                                                    <div className="Purchase-buttons">
                                                        <button type="submit" className="add-Purchase-button">
                                                            Update Purchase
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="cancel-Purchase-button"
                                                            onClick={() => {
                                                                setIsPopupMode(false);
                                                                setIsEditMode(false);
                                                                setFormData({
                                                                    purchaseInvoiceDate: "",
                                                                    purchaseInvoiceNumber: "",
                                                                    purchaseInvoiceAmount: "",
                                                                    supplierId: "",
                                                                    products: [
                                                                        {
                                                                            productId: "",
                                                                            purchaseProductCode: "",
                                                                            purchaseQuantity: 0,
                                                                            purchasePrice: 0,
                                                                            sellingPrice: 0,
                                                                        }
                                                                    ]
                                                                });
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>

                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {isPaymentPopupOpen && (() => {

                                // ✅ Define variables ONCE (ESLint safe)
                                const purchaseDetails = selectedPurchasePaymentLogs?.data?.data?.purchaseDetails;
                                const logs = selectedPurchasePaymentLogs?.data?.logs || [];

                                return (
                                    <div className="purchase-payment-popup-overlay">
                                        <div className="purchase-payment-popup-container">

                                            {/* Header */}
                                            <div className="purchase-payment-popup-header">
                                                <h2>Purchase Payment Logs</h2>
                                            </div>

                                            {/* If no data yet */}
                                            {!purchaseDetails ? (
                                                <p style={{ padding: 20, textAlign: "center" }}>Loading...</p>
                                            ) : (
                                                <>

                                                    {/* Purchase Details */}
                                                    <div className="purchase-payment-popup-section">
                                                        <h3>Purchase Details</h3>

                                                        <div className="details-grid">
                                                            <div><strong>Invoice No:</strong> {purchaseDetails.purchaseInvoiceNumber}</div>
                                                            <div><strong>Amount:</strong> ₹{purchaseDetails.purchaseInvoiceAmount}</div>
                                                            <div><strong>Status:</strong> {purchaseDetails.paymentStatus}</div>
                                                            <div><strong>Due:</strong> ₹{purchaseDetails.dueAmount}</div>

                                                            <div><strong>Supplier:</strong> {purchaseDetails.supplier?.supplierName}</div>
                                                            <div><strong>Mobile:</strong> {purchaseDetails.supplier?.mobileNumber}</div>
                                                            <div><strong>Email:</strong> {purchaseDetails.supplier?.email}</div>
                                                            <div><strong>City:</strong> {purchaseDetails.supplier?.city}</div>
                                                            <div><strong>State:</strong> {purchaseDetails.supplier?.state}</div>
                                                        </div>
                                                    </div>

                                                    <hr className="divider" />

                                                    {/* Payment History */}
                                                    <div className="purchase-payment-popup-section">
                                                        <h3>Payment History</h3>

                                                        {logs.length > 0 ? (
                                                            <div className="table-wrapper">
                                                                <table className="logs-table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>S.No</th>
                                                                            <th>Payment Mode</th>
                                                                            <th>Amount</th>
                                                                            <th>Reference No</th>
                                                                            <th>Remarks</th>
                                                                            <th>Date</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {logs.map((log, index) => (
                                                                            <tr key={log._id}>
                                                                                <td>{index + 1}</td>
                                                                                <td>{log.paymentMode}</td>
                                                                                <td>₹{log.paymentAmount}</td>
                                                                                <td>{log.referenceNo}</td>
                                                                                <td>{log.remarks}</td>
                                                                                <td>{new Date(log.createdAt).toLocaleString()}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ) : (
                                                            <p className="no-logs">No payment logs found.</p>
                                                        )}
                                                    </div>

                                                    <hr className="divider" />

                                                    {/* Add Payment Form */}
                                                    {showAddPaymentForm && (
                                                        <div className="popup-form">
                                                            <h2 className="popup-title">Add Payment Entry</h2>

                                                            <form
                                                                className="popup-form-body"
                                                                onSubmit={(e) => handleAddPurchasePayment(e, purchaseDetails.purchaseId)}
                                                            >

                                                                {/* Row 1 */}
                                                                <div className="form-group-row">

                                                                    <div className="form-group">
                                                                        <label>Payment Amount</label>
                                                                        <input
                                                                            type="number"
                                                                            required
                                                                            className="purchase-input"
                                                                            value={paymentForm.paymentAmount}
                                                                            onChange={(e) =>
                                                                                setPaymentForm({
                                                                                    ...paymentForm,
                                                                                    paymentAmount: e.target.value,
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label>Payment Mode</label>
                                                                        <select
                                                                            required
                                                                            className="purchase-input"
                                                                            value={paymentForm.paymentMode}
                                                                            onChange={(e) =>
                                                                                setPaymentForm({
                                                                                    ...paymentForm,
                                                                                    paymentMode: e.target.value,
                                                                                })
                                                                            }
                                                                        >
                                                                            <option value="">Select Mode</option>
                                                                            <option value="Cash">Cash</option>
                                                                            <option value="Card">Card</option>
                                                                            <option value="UPI">UPI</option>
                                                                            <option value="Bank Transfer">Bank Transfer</option>
                                                                        </select>
                                                                    </div>

                                                                </div>

                                                                {/* Row 2 */}
                                                                <div className="form-group-row">

                                                                    <div className="form-group">
                                                                        <label>Reference No</label>
                                                                        <input
                                                                            type="text"
                                                                            value={paymentForm.referenceNo}
                                                                            onChange={(e) =>
                                                                                setPaymentForm({
                                                                                    ...paymentForm,
                                                                                    referenceNo: e.target.value,
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label>Remarks</label>
                                                                        <input
                                                                            type="text"
                                                                            value={paymentForm.remarks}
                                                                            onChange={(e) =>
                                                                                setPaymentForm({
                                                                                    ...paymentForm,
                                                                                    remarks: e.target.value,
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>

                                                                </div>

                                                                <div className="form-actions">
                                                                    <button type="submit" className="btn-primary">
                                                                        Save Payment
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        className="btn-secondary"
                                                                        onClick={() => setShowAddPaymentForm(false)}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>

                                                            </form>
                                                        </div>
                                                    )}

                                                </>
                                            )}

                                            {/* Footer */}
                                            <div className="purchase-payment-popup-footer">
                                                {!showAddPaymentForm && purchaseDetails?.paymentStatus !== "Paid" && (
                                                    <button style={{ textAlign: "center", marginRight: 20 }}
                                                        className="btn-primary"
                                                        onClick={() => setShowAddPaymentForm(true)}
                                                    >
                                                        Add Payment
                                                    </button>
                                                )}
                                                <button
                                                    className="btn-close"
                                                    onClick={() => {
                                                        setShowAddPaymentForm(false);
                                                        setIsPaymentPopupOpen(false);
                                                    }}
                                                >
                                                    Close
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                );
                            })()}


                            {limit > 5 && purchases.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more purchases
                                    </Typography>
                                </div>
                            )}

                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this purchase?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: '#8D2629' }} onClick={handleDeletePurchase}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>

                            {openViewPopup && (
                                <ViewPurchasePopup
                                    data={viewPurchaseData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )}

                            {showLabelPopup && (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        background: "rgba(0,0,0,0.5)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 9999
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "#FFF",
                                            padding: "20px",
                                            borderRadius: "8px",
                                            width: "400px",
                                            textAlign: "center"
                                        }}
                                    >
                                        <h3>Label Preview</h3>

                                        {/* ⭐ ONE PRODUCT → ONE INPUT */}
                                        {printItems.length === 1 && (
                                            <div style={{ marginBottom: "10px" }}>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    value={printItems[0].printQty || 1}
                                                    onChange={(e) => {
                                                        const updated = [...printItems];
                                                        updated[0].printQty = Number(e.target.value);
                                                        setPrintItems(updated);
                                                    }}
                                                    style={{
                                                        padding: "8px",
                                                        width: "150px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #ccc",
                                                        textAlign: "center"
                                                    }}
                                                />
                                            </div>
                                        )}

                                        {/* ⭐ MULTIPLE PRODUCTS → INDIVIDUAL INPUTS */}
                                        {printItems.length > 1 && (
                                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                                <h4>Enter No. of Labels:</h4>

                                                {printItems.map((item, index) => (
                                                    <div key={index} style={{ marginBottom: "12px" }}>
                                                        <b>{item.labelData?.barcodeNumber}</b>
                                                        <br />
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            value={item.printQty || 1}
                                                            onChange={(e) => {
                                                                const updated = [...printItems];
                                                                updated[index].printQty = Number(e.target.value);
                                                                setPrintItems(updated);
                                                            }}
                                                            style={{
                                                                padding: "6px",
                                                                width: "80px",
                                                                borderRadius: "6px",
                                                                border: "1px solid #ccc",
                                                                marginTop: "5px"
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        <div
                                            style={{
                                                border: "1px solid #ccc",
                                                padding: "10px",
                                                marginBottom: "10px"
                                            }}
                                        >
                                            <LabelPrint58 ref={printRef} items={printItems} />

                                        </div>

                                        <button
                                            style={{
                                                background: "#8D2629",
                                                color: "#FFF",
                                                padding: "8px 14px",
                                                borderRadius: "6px",
                                                border: "none",
                                                fontWeight: "600",
                                                margin: "10px",
                                                cursor: "pointer"
                                            }}
                                            onClick={handlePrint}
                                        >
                                            Print
                                        </button>

                                        <button
                                            onClick={() => setShowLabelPopup(false)}
                                            style={{
                                                background: "#ccc",
                                                padding: "8px 14px",
                                                borderRadius: "6px",
                                                fontWeight: "600",
                                                cursor: "pointer"
                                            }}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            )}

                            <Dialog
                                open={openReturnModal}
                                onClose={() => setOpenReturnModal(false)}
                                fullWidth
                                maxWidth="sm"
                                PaperProps={{
                                    sx: {
                                        borderRadius: "14px",
                                        backgroundColor: "#FFF7D1",           // cream pastel background
                                        border: "3px solid #e6cf80",          // soft gold frame
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)"
                                    }
                                }}
                            >
                                <DialogTitle
                                    sx={{
                                        fontSize: "20px",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        color: "#8D2629",                     // deep wine title
                                        borderBottom: "2px solid #e6cf80",
                                        pb: 2
                                    }}
                                >
                                    Purchase Return
                                </DialogTitle>

                                <DialogContent sx={{ mt: 2 }}>
                                    {selectedPurchase?.products?.map((p, index) => {
                                        const hasColors =
                                            p.attributes &&
                                            p.attributes.length > 0 &&
                                            typeof p.attributes[0].values[0] === "object";

                                        return (
                                            <Box
                                                key={index}
                                                sx={{
                                                    mb: 3,
                                                    p: 2,
                                                    borderRadius: "12px",
                                                    backgroundColor: "white",
                                                    border: "2px solid #e6cf80",
                                                    boxShadow: "0 3px 6px rgba(0,0,0,0.07)"
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#8D2629",
                                                        fontWeight: 600,
                                                        mb: 1,
                                                        fontSize: "16px"
                                                    }}
                                                >
                                                    {selectedPurchase.productDetails?.[index]?.title}
                                                </Typography>

                                                {/* COLOR DROPDOWN */}
                                                {hasColors && (
                                                    <Box sx={{ mb: 2 }}>
                                                        <Typography sx={{ fontWeight: 500, color: "#8D2629" }}>
                                                            Select Color
                                                        </Typography>

                                                        <select
                                                            onChange={(e) =>
                                                                updateReturnItem(index, "color", e.target.value)
                                                            }
                                                            style={{
                                                                width: "96%",
                                                                padding: "10px",
                                                                marginTop: "6px",
                                                                borderRadius: "8px",
                                                                outline: "none",
                                                                fontSize: "14px",
                                                                border: "1px solid #e6cf80",
                                                            }}
                                                        >
                                                            <option value="">Choose a Color</option>
                                                            {p.attributes[0].values.map((v) => (
                                                                <option key={v.name} value={v.name}>
                                                                    {v.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </Box>
                                                )}

                                                {/* QTY INPUT */}
                                                <Box sx={{ mb: 2 }}>
                                                    <Typography sx={{ fontWeight: 500, color: "#8D2629" }}>
                                                        Quantity
                                                    </Typography>
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        placeholder="Enter quantity"
                                                        onChange={(e) =>
                                                            updateReturnItem(index, "qty", Number(e.target.value))
                                                        }
                                                        style={{
                                                            width: "92%",
                                                            padding: "10px",
                                                            marginTop: "6px",
                                                            borderRadius: "8px",
                                                            border: "1px solid #e6cf80",
                                                            background: "white",
                                                            fontSize: "14px",
                                                            outline: "none"
                                                        }}
                                                    />
                                                </Box>

                                                {/* RATE INPUT */}
                                                <Box>
                                                    <Typography sx={{ fontWeight: 500, color: "#8D2629" }}>
                                                        Rate
                                                    </Typography>
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        placeholder="Enter rate"
                                                        onChange={(e) =>
                                                            updateReturnItem(index, "rate", Number(e.target.value))
                                                        }
                                                        style={{
                                                            width: "92%",
                                                            padding: "10px",
                                                            marginTop: "6px",
                                                            borderRadius: "8px",
                                                            border: "1px solid #e6cf80",
                                                            background: "white",
                                                            fontSize: "14px",
                                                            outline: "none"
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </DialogContent>

                                <DialogActions sx={{ p: 2 }}>
                                    <Button
                                        onClick={() => setOpenReturnModal(false)}
                                        sx={{
                                            backgroundColor: "#e6cf80",
                                            color: "#8D2629",
                                            fontWeight: 600,
                                            px: 3,
                                            borderRadius: "8px",
                                            textTransform: "none",
                                            "&:hover": { backgroundColor: "#d8c270" }
                                        }}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        onClick={submitPurchaseReturn}
                                        sx={{
                                            backgroundColor: "#8D2629",
                                            color: "white",
                                            fontWeight: 600,
                                            px: 3,
                                            borderRadius: "8px",
                                            textTransform: "none",
                                            "&:hover": { backgroundColor: "#7a2022" }
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>

                    )
                    }
                </main>
            </div>
        </div>

    );
};

export default PurchasePage;